import Banner from './Banner';
import Concept from './Concept';
import Poster from './Poster';
import Member from './Member';
import Introduce from './Introduce';

export default function Home() {
  return (
    <>
      <Banner />
      <Concept />
      <Poster />
      <Member />
      <Introduce />
    </>
  );
}